import React from "react";
import { useSelector } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/firstRidersSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import FirstTimeRidesMonthToDate from "./smartComponents/firstTimeRidesMonthToDate";
import PreviousFirstTimeRidesMonthToDate from "./smartComponents/prevFirstTimeRidesMonthToDate";

import ClosingMonthToDate from "./smartComponents/closingMonthToDate";
import ClosingPercentMonthToDate from "./smartComponents/closingPercentMonthToDate";

import PreviousClosingMonthToDate from "./smartComponents/prevClosingMonthToDate";
import PreviousClosingPercentMonthToDate from "./smartComponents/prevClosingPercentMonthToDate";

import ClosingPieChart from "./smartComponents/closingPieChart";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { useFetchData } from "../hooks/dataFetchingHooks";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const FirstRidersModule = (props) => {
  useFetchData({
    moduleName: "firstRiders",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  const isLoading = useSelector((state) => state.firstRiders.isLoading);

  return (
    <SectionToggle
      title={props.moduleName}
      learnMore={
        <KBLearnMore
          title={props.moduleName}
          description="This report displays all first-time clients who completed their first visit, intro, or service with your business. These insights help you track early conversions, evaluate marketing effectiveness, and identify how well leads transition into paying clients."
          kbUrl={ILEARN_URLS.dashboard.firstTimeClients}
        />
      }
      customClass={`firstridersWidget ${isLoading ? "" : "active"}`}
      height={650}
      isLoading={isLoading}
      content={
        <div>
          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="Month To Date">
                <FirstTimeRidesMonthToDate />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer title="Previous Month To Date">
                <PreviousFirstTimeRidesMonthToDate />
              </SectionContainer>
            </span>
          </div>
          <div className="section-group">
            <span className="width-50 bottom" style={{ paddingBottom: "50px" }}>
              <SectionContainer title="Conversion % Month To Date">
                <ClosingPercentMonthToDate />
              </SectionContainer>
            </span>
            <span className="width-50 bottom" style={{ paddingBottom: "50px" }}>
              <SectionContainer title="Previous Month Conversion % MTD">
                <PreviousClosingPercentMonthToDate />
              </SectionContainer>
            </span>
          </div>
          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="Total Purchases Month to Date"></SectionContainer>
              <ClosingMonthToDate />
            </span>
            <span className="width-50">
              <SectionContainer title="Previous Month Purchase MTD">
                <PreviousClosingMonthToDate />
              </SectionContainer>
            </span>
          </div>
          <div className="section-group" style={{ height: "350px" }}>
            <SectionContainer title="Purchases Breakdown" customStyles="pie-chart">
              <ClosingPieChart />
            </SectionContainer>
          </div>
        </div>
      }
    />
  );
};

export default React.memo(FirstRidersModule);
